import { Component } from '@angular/core';
import { IonicPage, ViewController, NavParams } from 'ionic-angular';

import { Rank } from '../../models/rank.model';
import { User } from '../../models/user.model';

import { RankProvider } from '../../providers/rank/rank';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-rank-progress',
  templateUrl: 'rank-progress.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class RankProgressPage {

  ranks: Rank[];
  user: User;
  currentProgress: number;

  err: string;
  loading: boolean;

  constructor(public viewCtrl: ViewController, public navParams: NavParams, public rankProvider: RankProvider) {
    this.user = new User(this.navParams.get('user'));
  }

  private _calcPercent(ranks: Rank[]): Rank[] {
    let max:number = ranks[ranks.length - 1].from;
    ranks.forEach(r => {
      r.percent = (r.from != max) ? Math.round(r.from / max * 100) : 100;
    });
    return ranks;
  }

  private _calcCurrentProgress(points: number, ranks: Rank[]): number {
    let max:number = ranks[ranks.length - 1].from;
    return (parseInt(points.toString()) >= parseInt(max.toString())) ? 100 : Math.round(points / max * 100);
  }

  getRanks() {
    this.loading = true;
    this.rankProvider.getAll()
      .subscribe(
        ranks => {
          this.ranks = this._calcPercent(ranks);
          this.currentProgress = this._calcCurrentProgress(this.user.points, ranks);
        },
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    this.getRanks();
  }

}



// WEBPACK FOOTER //
// ./src/pages/rank-progress/rank-progress.ts